// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__F6Df4","inputWrap":"styles_inputWrap__2cX8X","input":"styles_input__R2YMo"};